import { EquationBase } from './base/equation-base';

export class Equation extends EquationBase { }